import { useTranslation } from 'react-i18next'
import { Text } from 'react-native'
import { DEFAULT_CURRENCY } from '@ca/common'
import { getLocaleCode } from 'hooks/useCurrency'
import { useRemoteConfig } from 'hooks/useRemoteConfigStore'
import { useAppRegion } from 'storage/useRemoteConfigParams'
import { useMemo } from 'react'

interface Props {
  value?: number
  hideCurrency?: boolean
  showZero?: boolean
  noPrecision?: boolean
  className?: string
}

export default function Price({
  value,
  hideCurrency,
  showZero,
  noPrecision,
  className,
}: Props) {
  const { i18n } = useTranslation()
  const config = useRemoteConfig()
  const currency = config?.region.currency || DEFAULT_CURRENCY

  const region = useAppRegion()

  const localeCode = useMemo(() => {
    return getLocaleCode(i18n.language, region)
  }, [i18n.language, region])

  const text = useMemo(() => {
    if (!value && !showZero) return '—'

    const options: Intl.NumberFormatOptions = {}

    if (noPrecision) {
      if ((value && value % 1 === 0) || (!value && showZero))
        options.minimumFractionDigits = 0
    }
    if (!hideCurrency) {
      options.style = 'currency'
      options.currency = currency
    }

    return new Intl.NumberFormat(localeCode, options).format(value || 0)
  }, [value, hideCurrency, showZero, noPrecision, currency, localeCode])

  return <Text className={className}>{text}</Text>
}
